import React from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';
import { ExpectedDeliveryDateEmptyView } from './ExpectedDeliveryDateEmptyView';
import { ExpectedDeliveryDateStep } from './ExpectedDeliveryDateModal';

interface IExpectedDeliveryDateEmptyResultsProps {
    step: ExpectedDeliveryDateStep;
    deliveryInfoUrl: string;
}

export const ExpectedDeliveryDateEmptyResults = ({ step, deliveryInfoUrl }: IExpectedDeliveryDateEmptyResultsProps) => {
    const seeMoreText = (
        <>
            <a href={deliveryInfoUrl}>{getTranslation(keys['expectedDeliveryDate.seeMore'])}</a>{' '}
            {getTranslation(keys['expectedDeliveryDate.aboutDeliveryMethods'])}
        </>
    );

    switch (step) {
        case ExpectedDeliveryDateStep.Init:
            return <ExpectedDeliveryDateEmptyView image="/dist/assets/images/no-postal-code.svg" />;
        case ExpectedDeliveryDateStep.NoAvailableMethods:
            return (
                <ExpectedDeliveryDateEmptyView
                    image="/dist/assets/images/anm-ed-no-methods.svg"
                    title={getTranslation(keys['expectedDeliveryDate.noMethods.title'])}
                    subtitle={getTranslation(keys['expectedDeliveryDate.noMethods.title'])}
                    additionalText={seeMoreText}
                />
            );
        default:
            return (
                <ExpectedDeliveryDateEmptyView
                    image="/dist/assets/images/anm-ed-no-data.svg"
                    title={getTranslation(keys['expectedDeliveryDate.unexpectedError.title'])}
                    subtitle={getTranslation(keys['expectedDeliveryDate.unexpectedError.title'])}
                    additionalText={seeMoreText}
                />
            );
    }
};
